import gql from "graphql-tag";

export const instagramtag = gql`
  fragment InstagramtagFragment on InstagramInsTag {
    id
    pcx
    pcy
    mbx
    mby
    productvariant {
      id
      variantId
      sku
      name
      skuName
      urlSlug
      product {
        id
        name
        thumbnail {
          url
        }
      }
      margin
      trackInventory
      attributes {
        values {
          value: name
        }
      }
    }
  }
`;

export const instagramFragment = gql`
  ${instagramtag}
  fragment InstagramFragment on Instagram {
    id
    instagramId
    shortcode
    image
    username
    url
    likes
    comments
    createTime
    published
    updateTime
    istop
    userpicUrl
    mimeType
    platForm
    startTime
    intervalTime
    instagramtag {
      ...InstagramtagFragment
    }
    number
    products {
      id
      visible
      product {
        id
        name
        isPublished
        # productIns {
        #   visible
        # }
        productType {
          id
          name
        }
        thumbnail {
          url
        }
      }
    }
  }
`;

export const instagramNoProductFragment = gql`
  fragment InstagramNoProductFragment on Instagram {
    id
    instagramId
    shortcode
    image
    imageThumb
    username
    url
    likes
    comments
    createTime
    published
    updateTime
    istop
    userpicUrl
    mimeType
    platForm
    number
  }
`;
